var PlatformService = /** @class */ (function () {
    function PlatformService(api) {
        this.API = api;
    }
    PlatformService.prototype.fetchPlatformVersion = function () {
        return this.API.get('/platform/version');
    };
    PlatformService.prototype.fetchPlatformVersionFull = function () {
        return this.API.get('/platform/versionfull');
    };
    return PlatformService;
}());
export { PlatformService };
